export default __webpack_public_path__ + "static/media/mq.007386bd.svg";